module.exports = __webpack_public_path__ + "static/affinity-7ade8abfe65debcbc610247b27584e91.jpg";